import { usePromotePageState } from 'src/app/pages/promote/pageContext';
import type { PaymentType } from 'src/app/shared/utils/payments';

import { useTracking } from '../useTracking';

export function useBeforeToken(): (paymentType: PaymentType) => Promise<boolean> {
	const [, { clearGeneralErrorMessage, setLoading }] = usePromotePageState();
	const { trackSubmit } = useTracking();

	return async function beforeToken(paymentType: PaymentType): Promise<boolean> {
		clearGeneralErrorMessage();
		setLoading();
		trackSubmit({ paymentType });
		return Promise.resolve(true);
	};
}
